import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { exchangeSessionId } from "../lib/auth";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sid = params.get("session_id");

    if (!sid) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const user = await exchangeSessionId(sid);
        toast.success(`Welcome, ${user.name?.split(" ")[0] || "there"}!`);
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
      } finally {
        // strip hash + redirect home
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true, state: { authed: true } });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="flex items-center gap-3 text-zinc-700">
        <Loader2 className="animate-spin" size={20} />
        <span className="text-sm font-medium">Signing you in…</span>
      </div>
    </div>
  );
}
